import MultiplierInput from 'components/Multipliers/MultiplierInput'
import React from 'react'

export default function BrandMultiplierItem(props) {
    const { brandItem, brandItemIndex, updateMultiplier, multiplier } = props
    return (
        <React.Fragment>

            <div className="frac shrunk pad-12-L pad-12-R"
                data-index={brandItemIndex}
                data-key={brandItem.manufacturer_id}
                key={brandItem.manufacturer_id}>
                <div className="frac-item">
                    <div className="top-sec">
                        <div
                            className="category-name d-flex justify-content-between align-items-center text-decoration-none">
                            <span className="d-flex align-items-center">
                                {brandItem.manufacturer_name}
                            </span>
                            <MultiplierInput
                                onChange={updateMultiplier}
                                id={brandItem.manufacturer_id}
                                multiplier={multiplier.b_multiplier}
                                multiplierType={multiplier.b_multiplier_type}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}
